import { render, staticRenderFns } from "./CompareMultipleContractsPage.vue?vue&type=template&id=6489e12b&scoped=true"
import script from "./CompareMultipleContractsPage.vue?vue&type=script&lang=js"
export * from "./CompareMultipleContractsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489e12b",
  null
  
)

export default component.exports